export default {
  FETCH_DEVICE: 'deviceDetails/FETCH_DEVICE',
  CREATE_DEVICE: 'deviceDetails/CREATE_DEVICE',
  DELETE_DEVICE: 'deviceDetails/DELETE_DEVICE',
  CREATE_FIRMWARE: 'deviceDetaisl/CREATE_FIRMWARE',
  DELETE_FIRMWARE: 'deviceDetails/DELETE_FIRMWARE',
  UPDATE_DEVICE: 'deviceDetails/UPDATE_DEVICE',
  UPDATE_FIRMWARE: 'deviceDetails/UPDATE_FIRMWARE',
};
